var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"search-label-body",class:{ 'label-hidden': _vm.labelHidden },style:(_vm.gridStyle)},[_c('div',{staticClass:"search-label-body-container"},[(!_vm.labelHidden)?_c('span',[_vm._v(_vm._s(_vm.label || ''))]):_vm._e(),_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }